import { combineReducers } from 'redux'

import avatars from './avatars'
import characterId from './characterId'
import characters from './characters'
import client from './client'
import customInitiativeEntries from './customInitiativeEntries'
import encounters from './encounters'
import encounter_monsters from './encounter_monsters'
import game from './game'
import game_roles from './game_roles'
import game_settings from './game_settings'
import groupRolls from './groupRolls'
import groupRollDefaults from './groupRollDefaults'
import invitations from './invitations'
import monsters from './monsters'
import ownerId from './ownerId'
import registries from './registries'
import rolls from './rolls'
import shortcuts from './shortcuts'
import variables from './variables'
import history from './history'
import initiativeQueue from './initiativeQueue'
import initiativeQueueItems from './initiativeQueueItems'
import user from './user.js'
import pixels from './pixels'

export default combineReducers({
    avatars,
    characterId,
    characters,
    client,
    customInitiativeEntries,
    encounters,
    encounter_monsters,
    game,
    game_roles,
    game_settings,
    groupRolls,
    groupRollDefaults,
    invitations,
    monsters,
    ownerId,
    registries,
    rolls,
    shortcuts,
    variables,
    history,
    initiativeQueue,
    initiativeQueueItems,
    user,
    pixels,
})
